import React, { useState } from "react"
import {
  Card,
  Col,
  Container,
  Row,
  CardBody,
  CardTitle,
  Label,
  Button,
  Form,
  Input,
  InputGroup,
  FormFeedback,
} from "reactstrap"
import * as Yup from "yup"
import Breadcrumbs from "../../../components/Common/Breadcrumb"
import { useFormik } from "formik"
import { ToastContainer, toast } from "react-toastify"
import "react-toastify/dist/ReactToastify.css"

import { useSelector, useDispatch } from "react-redux"
import { withRouter, Link } from "react-router-dom"

// actions
import { addCertificate } from "../../../store/actions"
import { useEffect } from "react"

const AddEnvCerts = props => {
  const dispatch = useDispatch()
  document.title = "Add Certs"

  const validation = useFormik({
    enableReinitialize: true,
    initialValues: {
      certification: "",
    },
    validationSchema: Yup.object({
      certification: Yup.string().required("Please Enter Env Certificate"),
    }),
    onSubmit: values => {
      dispatch(addCertificate(values, props.history))
    },
  })

  const certs = useSelector(state => state.environmentalAndHealthCertification)
  const { error } = useSelector(state => ({
    error: state.environmentalAndHealthCertification.error,
  }))

  useEffect(() => {
    if (error) {
      toast.dismiss()
      toast.error(error, {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: false,
        progress: undefined,
      })
    }
  }, [error])

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid={true}>
          <Breadcrumbs breadcrumbItem="Add Environment and Health Certification" />
          <Row>
            <Col lg={12}>
              <Card>
                <CardBody>
                  {error ? <ToastContainer /> : ""}
                  <Form
                    id="form"
                    onSubmit={e => {
                      e.preventDefault()
                      validation.handleSubmit()
                      return false
                    }}
                  >
                    <Row>
                      <Col md={6}>
                        <div className="mb-3">
                          <Label htmlFor="certs">
                            Environment and Health Certification
                            <span className="text-danger">*</span>
                          </Label>
                          <Input
                            type="text"
                            name="certification"
                            autoComplete="off"
                            className={
                              validation.touched.certification &&
                              validation.errors.certification
                                ? "form-control is-invalid"
                                : "form-control"
                            }
                            id="certs"
                            placeholder="Enter"
                            onChange={validation.handleChange}
                            onBlur={validation.handleBlur}
                            value={validation.values.certification || ""}
                          />
                          {validation.touched.certification &&
                          validation.errors.certification ? (
                            <FormFeedback type="invalid">
                              {validation.errors.certification}
                            </FormFeedback>
                          ) : null}
                        </div>
                      </Col>
                    </Row>
                    <div>
                      {certs && certs.loading ? (
                        <button
                          type="submit"
                          className="btn btn-primary w-md"
                          disabled
                        >
                          Adding ...
                        </button>
                      ) : (
                        <button type="submit" className="btn btn-primary w-md">
                          Add
                        </button>
                      )}
                    </div>
                  </Form>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
        {/* container-fluid */}
      </div>
    </React.Fragment>
  )
}

export default AddEnvCerts
